import { css } from '@emotion/css';
import {
  N0,
  N50,
  Y50,
  Y500,
  N900,
  primaryDark,
  primary,
  primaryLight,
  primaryBackground,
} from '@assets/colors';

export const styContainer = css`
  position: absolute;
  right: 16px;
  margin-top: -50px;
  z-index: 2;
`;

export const styContent = css`
  box-shadow: 0 4px 8px 0 rgba(51, 51, 51, 0.16);
  border: 1px solid ${N50};
  background-color: ${N0};
  display: flex;
  align-items: center;
`;

export const styDateContainer = css`
  .react-datepicker-wrapper {
    width: 100%;
  }

  input {
    height: 32px;
    padding: 8px;
    font-size: 13px;
    border: 1px solid ${N50};
    display: block;
    width: 100%;
    line-height: 1.5;
    border-radius: 4px;
    outline: none;
  }

  img {
    position: absolute;
    right: 8px;
    top: 5px;
  }
`;

export const styCloseBtn = css`
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
`;

export const styFrame = css`
  background: ${Y50};
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  margin-top: 24px;
`;

export const styBtnTopUp = css`
  border-radius: 4px !important;
  background-color: ${Y500} !important;
  padding: 4px 8px !important;
  color: ${primaryDark} !important;
  font-size: 12px !important;
`;

export const styPopUpActions = css`
  background-color: ${N0};
  border-top: 1px solid ${N50};
`;

export const styMdlConfirm = css`
  padding: 16px 24px 24px;
  text-align: center;
`;

export const styCustomPopupDialog = css`
  section {
    margin: 0 auto;
    max-width: 415px;
  }
`;

export const styPopupHeader = css`
  text-align: center;
  padding: 24px;
`;

const styles = {
  container: {
    paddingTop: 40,
    paddingLeft: 40,
    paddingRight: 40,
  },
  card: {
    border: 'none',
  },
  cardHeader: {
    border: 'none',
    background: 'none',
    boxSizing: 'unset',
    paddingLeft: 0,
    paddingRight: 0,
  },
  cardHeaderHover: {
    border: 'none',
    boxSizing: 'unset',
    paddingLeft: 0,
    paddingRight: 0,
    background: primaryBackground,
  },
  detailCard: {
    border: `solid 1px ${N50}`,
    backgroundColor: 'rgba(245, 245, 245, 0.3)',
    padding: 16,
  },
  dataContainer: {
    height: 450,
  },
  lineConnectorWithdraw: {
    minHeight: 50,
    borderLeft: `1px solid ${N50}`,
    marginLeft: 11,
    marginTop: -40,
    zIndex: 8,
  },
  lineConnectorDeposit: {
    minHeight: 50,
    borderLeft: `1px solid ${N50}`,
    marginLeft: 11,
    marginTop: -40,
    zIndex: 8,
  },
  popupInfo: {
    margin: 0,
    padding: '32px 16px 32px 34px',
  },
  onGoingPills: {
    backgroundColor: Y50,
    color: Y500,
    borderRadius: '16px',
    padding: '4px 8px',
    fontSize: '12px',
  },
  donePills: {
    backgroundColor: primaryLight,
    color: primary,
    borderRadius: '16px',
    padding: '4px 8px',
    fontSize: '12px',
  },
  searchFund: {
    backgroundColor: N0,
    width: 'calc(100% - 48px)',
    height: 40,
    paddingTop: 11,
    paddingBottom: 11,
    paddingLeft: 8,
    fontSize: 13,
    border: `1px solid ${N50}`,
    borderRadius: '8px',
    colors: N900,
    boxShadow: 'none',
    outline: 'none',
  },
  modalCard: {
    minHeight: '400px',
    maxHeight: 'calc(100vh - 180px)',
    overflowY: 'auto',
  },
  imgStepper: { width: '24px', height: '24px', zIndex: 2 },
};

export default styles;
